import { useMemo } from 'react';
import usePageMeta from '@/hooks/usePageMeta';
import { faqs } from '@/mocks/site';
import HeroSection from './components/HeroSection';
import HotRankSection from './components/HotRankSection';
import CategorySection from './components/CategorySection';
import FeedSection from './components/FeedSection';
import VoicesSection from './components/VoicesSection';
import FaqSection from './components/FaqSection';
import SubmitSection from './components/SubmitSection';

export default function Home() {
  const jsonLd = useMemo(
    () => [
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: '高校吃瓜社',
        alternateName: '高校吃瓜',
        description:
          '聚焦高校吃瓜事件与高校吃瓜热点，实时围观校园热门现场，提供高校吃瓜爆料与话题追踪。',
        inLanguage: 'zh-CN',
        potentialAction: {
          '@type': 'SearchAction',
          target: `${window.location.origin}${(__BASE_PATH__ || '/').replace(/\/$/, '')}/events?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: '高校吃瓜社',
        description: '专注校园公共话题整理与话题追踪的内容社区。',
        email: 'contact@gaoxiaochigua.com',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqs.map((faq) => ({
          '@type': 'Question',
          name: faq.question,
          acceptedAnswer: { '@type': 'Answer', text: faq.answer },
        })),
      },
    ],
    []
  );

  usePageMeta({
    title: '高校吃瓜｜高校吃瓜事件 高校吃瓜热点 围观热门现场直击报道',
    description:
      '高校吃瓜社聚焦高校吃瓜事件与高校吃瓜热点，实时围观校园热门现场，整理高校吃瓜爆料与话题时间线，前后经过一次看清，吃瓜不迷路。',
    keywords: '高校吃瓜,高校吃瓜事件,高校吃瓜热点,高校吃瓜爆料,高校吃瓜新闻',
    canonicalPath: '/',
    ogType: 'website',
    jsonLd,
  });

  return (
    <>
      <HeroSection />
      <HotRankSection />
      <CategorySection />
      <FeedSection />
      <VoicesSection />
      <FaqSection />
      <SubmitSection />
    </>
  );
}